module.exports = __webpack_public_path__ + "static/media/date.05387d11.svg";